import React from 'react';
import { Menu, Network } from 'lucide-react';

interface TopBarProps {
  onMenuClick: () => void;
}

export default function TopBar({ onMenuClick }: TopBarProps) {  
  return (
    <header className="h-16 bg-dark-800 border-b border-dark-700 px-6 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <button
          onClick={onMenuClick}
          className="text-gray-400 hover:text-white p-1 -ml-2"
          aria-label="Toggle menu"
        >
          <Menu className="w-6 h-6" />
        </button>
        {/* Show NRM logo on mobile */}
        <div className="lg:hidden flex items-center gap-2 text-primary-500">
          <Network className="w-6 h-6" />
          <span className="font-bold text-xl">NRM</span>
        </div>
      </div>
    </header>
  );
}